import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

  static values = {
    isLoginSuccess: Boolean,
    pageType: String
  }

  connect() {
    console.log("app_support_controller attached...")
    this.processIsLoginSuccess(this.isLoginSuccessValue)
    this.processPageType(this.pageTypeValue)
  }

  processIsLoginSuccess(isLoginSuccess) {
    if (isLoginSuccess) {
      Android.loggedIn()
    }
  }

  processPageType(pageType) {
     Android.navigation(pageType)
  }
}
